import { AssistantType } from '@vendasta/ai-assistants';

export const VENDASTA_PARTNER = 'VA';

export const SMSConnectionID = 'CONNECTION-sms';

export const VoiceConnectionID = 'CONNECTION-voice';

export const knowledgeAppType = 'AIAssistant';

export const SYSTEM_ASSISTANT_ID = 'ASSISTANT-system';
export const DEFAULT_CHAT_RECEPTIONIST_AVATAR_SVG_ICON = 'ai-chat-receptionist';
export const VENDASTA_AI_AVATAR_SVG_ICON = 'vendasta-ai';
export const DEFAULT_AVATAR_SVG_ICON = 'galaxy-ai-icon-with-background';

export const CUSTOM_ASSISTANTS = 'custom_ai_assistants';
export const AI_MEETING_BOOKING = 'ai_meeting_booking';
export const VOICE_AI_MEETING_BOOKING = 'voice_ai_meeting_booking';
export const NEW_CUSTOM_AI_GOALS = 'custom_ai_goals';

export const DEEPGRAM_SPEAK_FEATURE_FLAG = 'deepgram_speak';
export const ELEVEN_LABS_SPEAK_FEATURE_FLAG = 'modular_voice_integration';
export const LANGCHAIN_FEATURE_FLAG = 'langchain';
export const CONFIG_PAGE_V2_FEATURE_FLAG = 'show_assistant_config_v2';

export const WEBCHAT_WIDGET_CONNECTION_TYPE = 'WebchatWidget';

export const ASSISTANT_ID_CHAT_RECEPTIONIST = 'ASSISTANT-chat-receptionist';
export const ASSISTANT_ID_VOICE_RECEPTIONIST = 'ASSISTANT-voice-receptionist';
export const ASSISTANT_ID_CONTENT_CREATOR = 'ASSISTANT-content-creator';
export const ASSISTANT_ID_REVIEW_MANAGER = 'ASSISTANT-review-manager';
export const ASSISTANT_ID_SEO_ANALYST = 'ASSISTANT-seo-analyst';
export const ASSISTANT_ID_SALES_COACH = 'ASSISTANT-sales-coach';
export const disabled_card_colour = '#e0e0e0';
export const DEFAULT_CONNECTION_PREFIX = 'default-';

export const WEBCHAT_ICON = 'https://vstatic-prod.apigateway.co/business-center-client.9223372035102012180.prod/assets/webchat-icon.svg';
export const SMS_ICON = 'https://vstatic-prod.apigateway.co/business-center-client.9223372035102012180.prod/assets/phone.svg';
export const VOICE_ICON = 'https://vstatic-prod.apigateway.co/business-center-client.9223372035102012180.prod/assets/old-phone.svg';

export const HIDDEN_GOAL_IDS = [
  'DefaultSMSPersonality',
  'DefaultContext',
  'DefaultPersonality',
  'DefaultVoiceKnowledge',
  'DefaultKnowledge',
  'DefaultVoiceContext',
  'DefaultSMSPersonality',
  'DefaultVoicePersonality',
  'DefaultWhatsAppPersonality',
  'DefaultReviewPersonality',
  'DefaultVoiceCommunicationStyle',
];

export const DEFAULT_ASSISTANT_NAMES = new Map<AssistantType, string>([
  [AssistantType.ASSISTANT_TYPE_UNSPECIFIED, 'AI Assistant'],
  [AssistantType.ASSISTANT_TYPE_CUSTOM, 'Custom Assistant'],
  [AssistantType.ASSISTANT_TYPE_VOICE_RECEPTIONIST, 'Voice Receptionist'],
  [AssistantType.ASSISTANT_TYPE_SALES_COACH, 'Sales Coach'],
  [AssistantType.ASSISTANT_TYPE_SYSTEM, 'System'],
  [AssistantType.ASSISTANT_TYPE_INBOX, 'Chat Receptionist'],
  [AssistantType.ASSISTANT_TYPE_REPUTATION_MANAGEMENT_REVIEW_AGENT, 'Review Manager'],
  [AssistantType.ASSISTANT_TYPE_SOCIAL_MARKETING, 'SEO Analyst'],
]);

// Default global goals
export const DEFAULT_LEAD_CAPTURE_GOAL_ID = 'DefaultLeadCapture';
export const DEFAULT_MEETING_BOOKING_GOAL_ID = 'BookAppointmentsWithBookMeNow';
export const ADDITIONAL_INSTRUCTIONS_GOAL_ID = 'AdditionalInstructions';
export const DEFAULT_VOICE_LEAD_CAPTURE_GOAL_ID = 'DefaultVoiceLeadCapture';
